import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const ViewVisaLinkButton = ({ userId, className = "yes-btn" }) => {
  const [loading, setLoading] = useState(false);
  const [visaLink, setVisaLink] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const normalizeData = (data) => {
    if (!data) return null;
    if (data.visa) return data.visa;
    if (data.data?.visa) return data.data.visa;
    if (Array.isArray(data.data) && data.data.length > 0) return data.data[0];
    if (data.data && typeof data.data === "object") return data.data;
    if (Array.isArray(data) && data.length > 0) return data[0];
    if (typeof data === "object") return data;
    return null;
  };

  const fetchVisaLink = async () => {
    if (!userId) return;

    try {
      setLoading(true);
      const res = await axios.get(
        `https://eventscons.com/eventbackendnew/api/visa?user_id=${userId}`
      );
      const mapped = normalizeData(res.data);

      const link = mapped?.url || "";
      setVisaLink(link);
      setShowPopup(true);

      if (!link) {
        toast.error("Visa link not found");
      }
    } catch (error) {
      setVisaLink("");
      setShowPopup(true);
      toast.error("Failed to fetch visa link");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userId) {
      setVisaLink("");
      setShowPopup(false);
    }
  }, [userId]);

  if (!userId) return null;

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={fetchVisaLink}
        disabled={loading}
        style={{width:'fit-content'}}
      >
        {loading ? "Loading..." : "Do I need a visa?check"}
      </button>

      {showPopup && (
        <div className="popup-overlay">
          <div
            className="popup-content"
            style={{
              minWidth: "500px",
              maxWidth: "600px",
              position: "relative",
              background: "#fff",
              padding: "30px",
              borderRadius: "16px",
            }}
          >
            <button
              className="popup-close"
              onClick={() => setShowPopup(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                fontSize: "24px",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              ✖
            </button>

            {visaLink ? (
              <>
                <div style={{ margin: "20px 0" }}>
                  <label
                    style={{
                      fontWeight: "600",
                      display: "block",
                      marginBottom: "10px",
                    }}
                  >
                    Visa Link:
                  </label>
                  <input
                    type="text"
                    value={visaLink}
                    readOnly
                    style={{
                      width: "100%",
                      padding: "15px",
                      border: "2px solid #4caf50",
                      borderRadius: "25px",
                      opacity: "0.9",
                      fontSize: "14px",
                      textAlign: "center",
                      background: "#f1f8e9",
                    }}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "15px",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    onClick={() =>
                      window.open(visaLink, "_blank", "noopener,noreferrer")
                    }
                    style={{
                      background: "#4caf50",
                      color: "white",
                      padding: "15px 30px",
                      border: "none",
                      borderRadius: "25px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      fontSize: "16px",
                    }}
                  >
                    Open Visa Link
                  </button>

                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(visaLink);
                      toast.success("Visa link copied to clipboard!");
                    }}
                    style={{
                      background: "#2196f3",
                      color: "white",
                      padding: "15px 30px",
                      border: "none",
                      borderRadius: "25px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      fontSize: "16px",
                    }}
                  >
                    Copy Link
                  </button>
                </div>
              </>
            ) : (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <h3 style={{ color: "#d32f2f" }}>Visa link not provided yet.</h3>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ViewVisaLinkButton;